export enum ActivityDataType {
  NONE = '',
  CONTINUOUS_MEASUREMENT = 'ACTIVITY_DATA_TYPE_1',
  PERIODIC_INTERMITTENT_MEASUREMENT = 'ACTIVITY_DATA_TYPE_2',
  SELF_ASSESSMENT = 'ACTIVITY_DATA_TYPE_3',
}

export enum ActivityDataConfidenceType {
  NONE = '',
  EXTERNAL_CORRECTIONS = 'ACTIVITY_CON_TYPE_1',
  INTERNAL_CORRECTIONS = 'ACTIVITY_CON_TYPE_2',
  NO_CALIBRATION_OR_CONSOLIDATION = 'ACTIVITY_CON_TYPE_3',
}

export enum RenewableEnergyType {
  NA = 'NA',
  SOLAR_T_REC = 'RENEWABLE_ENERGY_TYPE_2',
  BIOMASS_T_REC = 'RENEWABLE_ENERGY_TYPE_3',
  WIND_POWER = 'RENEWABLE_ENERGY_TYPE_4',
  HYDROPOWER = 'RENEWABLE_ENERGY_TYPE_5',
  GEOTHERMAL_ENERGY = 'RENEWABLE_ENERGY_TYPE_6',
  HYDROGEN_ENERGY = 'RENEWABLE_ENERGY_TYPE_7',
  SOLID_FUEL = 'RENEWABLE_ENERGY_TYPE_8',
  OCEAN_ENERGY = 'RENEWABLE_ENERGY_TYPE_9',
}

export enum EmissionKind {
  PRIMARY_MATERIAL = 'PRIMARY_MATERIAL',
  SECONDARY_MATERIAL = 'SECONDARY_MATERIAL',
  SUPPORT_MATERIAL = 'SUPPORT_MATERIAL',
  PACKAGE_MATERIAL = 'PACKAGE_MATERIAL',
}

export enum ActivityUnit {
  // linear
  MM = 'MM',
  CM = 'CM',
  M = 'M',
  KM = 'KM',
  INCH = 'INCH',
  FEET = 'FEET',
  YARD = 'YARD',
  MILE = 'MILE',
  NMI = 'NMI',

  // square
  M2 = 'M2',
  KM2 = 'KM2',
  HECTARE = 'HECTARE',
  ACRE = 'ACRE',

  // cubic
  ML = 'ML',
  L = 'L',
  PINT = 'PINT',
  GALLON = 'GALLON',
  BUSHEL = 'BUSHEL',
  KL = 'KL',
  M3 = 'M3',
  THOUSAND_M3 = 'THOUSAND_M3',
  KM3 = 'KM3',
  CM3 = 'CM3',
  MM3 = 'MM3',
  MILLION_L = 'MILLION_L',

  // weight
  MG = 'MG',
  G = 'G',
  KG = 'KG',
  T = 'T',
  KT = 'KT',
  OUNCE = 'OUNCE',
  POUND = 'POUND',
  LONG_TON = 'LONG_TON',
  SHORT_TON = 'SHORT_TON',
  TDM = 'TDM',

  // energy_kwh
  KWH = 'KWH',
  KWH_GROSS_CV = 'KWH_GROSS_CV',
  MWH = 'MWH',

  // energy_j
  MJ = 'MJ',
  GJ = 'GJ',
  TJ = 'TJ',

  // power
  WATT = 'WATT',

  // CURRENCY
  CURRENCY = 'CURRENCY',
  MEU = 'MEU',
  THOUSAND_EU = 'THOUSAND_EU',
  EUR = 'EUR',
  USD = 'USD',

  // other
  PERSON_DAY = 'PERSON_DAY',
  ROLL = 'ROLL',
  PACKET = 'PACKET',
  PIECE = 'PIECE',
  PAIR = 'PAIR',
  EACH = 'EACH',
  SHEET_1 = 'SHEET_1',
  STRIP = 'STRIP',
  UNIT = 'UNIT',
  CAN = 'CAN',
  BOX_1 = 'BOX_1',
  BOTTLE = 'BOTTLE',
  BUCKET = 'BUCKET',
  BOWL = 'BOWL',
  PKM = 'PKM',
  TKM = 'TKM',
  PERSON_TIME = 'PERSON_TIME',
  TEU = 'TEU',
  TEU_KM = 'TEU_KM',
  BAG = 'BAG',
  M2_HOUR = 'M2_HOUR',
  PERSON = 'PERSON',
  PERSON_HOUR = 'PERSON_HOUR',
  SQUARE_FOOT_DAY = 'SQUARE_FOOT_DAY',
  ROOM_DAY = 'ROOM_DAY',
  GUEST_NIGHT = 'GUEST_NIGHT',
  ITEM = 'ITEM',
  SERVICE = 'SERVICE',
  PERSON_MEAL = 'PERSON_MEAL',
  SET = 'SET',
  CUP = 'CUP',
  KG_DAY = 'KG_DAY',
  KM_YEAR = 'KM_YEAR',
  M_YEAR = 'M_YEAR',
  M2_YEAR = 'M2_YEAR',
  KG_BOD = 'KG_BOD',
  HEAD_YEAR = 'HEAD_YEAR',
  FLOOR = 'FLOOR',
  VEHICLE = 'VEHICLE',
  COPY = 'COPY',
  YEAR_KM2 = 'YEAR_KM2',
  WELL_UNIT = 'WELL_UNIT',
  HEAD = 'HEAD',
  WING = 'WING',
  SCF = 'SCF',
  TON_PER_YEAR = 'TON_PER_YEAR',
  MMBTU = 'MMBTU',
  PM = 'PM',
  HP_HR = 'HP_HR',
  TON_PER_DAY = 'TON_PER_DAY',
  HOUR = 'HOUR',
  HOURS = 'HOURS',
  MINS = 'MINS',
  SEC = 'SEC',
  LUMPSUM = 'LUMPSUM',
  FUNCTIONAL_UNIT = 'FUNCTIONAL_UNIT',
  WATTPEAK = 'WATTPEAK',
  M3_HOUR = 'M3_HOUR',
  TONNE_OF_OIL_EQU = 'TONNE_OF_OIL_EQU',
  DEVICE = 'DEVICE',
  MEAL = 'MEAL',
  M3_KM = 'M3_KM',
  PASSENGER_EQU_KM = 'PASSENGER_EQU_KM',
  PERSON_MONTH = 'PERSON_MONTH',
  SHORT_TON_MILE = 'SHORT_TON_MILE',
  VEHICLE_MILE = 'VEHICLE_MILE',
  '10K_WB' = '10K_WB',
  PC = 'PC',
  SPC = 'SPC',
  KPC = 'KPC',
  SML = 'SML',
  EA = 'EA',
}

export enum HypotheticalSituationType {
  ACTUAL_USAGE = 'ACTUAL_USAGE',
  INVENTORY_EST = 'INVENTORY_EST',
  FINANCIAL_EST = 'FINANCIAL_EST',
  AVG_FUGITIVE_METH = 'AVG_FUGITIVE_METH',
  RULE_PER_PERSON_PER_HOURS = 'RULE_PER_PERSON_PER_HOURS',
  RULE_TOTAL_WORKING_HOURS = 'RULE_TOTAL_WORKING_HOURS',
  ACTUAL_FILL_CAL = 'ACTUAL_FILL_CAL',
}

export enum MetadataType {
  WastewaterResidential = 'WastewaterResidential',
  WastewaterIndustrial = 'WastewaterIndustrial',
  WastewaterOther = 'WastewaterOther',
}

export enum CatOfActivityRelatedToFuelEnergyFromCat1And2 {
  CARFE_1 = 'CARFE_1',
  CARFE_2 = 'CARFE_2',
  CARFE_3 = 'CARFE_3',
}

export enum CatOfActivityRelatedToFuelEnergy {
  CARFE_4 = 'CARFE_4',
  CARFE_5 = 'CARFE_5',
  CARFE_6 = 'CARFE_6',
}

export enum Identity {
  EMPLOYEE = 'IDENTITY_EMPLOYEE',
  VISITOR = 'IDENTITY_VISITOR',
}
